import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=a4f473dc&scoped=true&"
import script from "./AlertBanner.vue?vue&type=script&lang=js&"
export * from "./AlertBanner.vue?vue&type=script&lang=js&"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=a4f473dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f473dc",
  null
  
)

export default component.exports